import React from 'react';

import type { MediaFactComponent } from '../../../../../core/data-sources/content-components/types.js';

import Text from '../articleComponents/Text/Text.js';
import { useByfunnPulseContext } from '../../../../pulse/index.js';

const FactBox: React.FC<MediaFactComponent> = ({ paragraphs }) => {
  const { trackClickUIElement } = useByfunnPulseContext();

  const trackToggle = (event: React.SyntheticEvent<HTMLDetailsElement>) => {
    const isOpen = event.currentTarget.open;

    trackClickUIElement(
      {
        object: {
          id: `article:factbox-button-${isOpen ? 'open' : 'close'}`,
          name: 'Factbox button',
          elementType: 'Details',
        },
      },
      {
        object: {
          objectId: `factbox-button-${isOpen ? 'open' : 'close'}`,
          name: 'Factbox button',
          elementType: 'Details',
        },
        placement: { containerName: 'page' },
      },
    );
  };

  return (
    <details className="media-fact-box" onToggle={trackToggle}>
      <summary>
        <p className="fact-title-intro">FAKTA</p>
        <div className="dropdown-button" />
      </summary>
      <div className="fact-content">
        <Text paragraphs={paragraphs} type="text" isFact />
      </div>
    </details>
  );
};

export default FactBox;
